import { render, staticRenderFns } from "./PainSpotShare.vue?vue&type=template&id=14154c70&scoped=true"
import script from "./PainSpotShare.vue?vue&type=script&lang=js"
export * from "./PainSpotShare.vue?vue&type=script&lang=js"
import style0 from "./PainSpotShare.vue?vue&type=style&index=0&id=14154c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14154c70",
  null
  
)

export default component.exports